var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("stat-layout-card", {
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _c("h2", { staticClass: "m-0" }, [_vm._v(_vm._s(_vm.data.title))])
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _vm.items.length > 0
              ? _c(
                  "ul",
                  { staticClass: "m-0" },
                  _vm._l(_vm.items, function(item, itemIndex) {
                    return _c(
                      "li",
                      { key: itemIndex, ref: "products", refInFor: true },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "px-5 py-2 fs-3 hover-primary-05-bkg cpointer flex-level gray-100",
                            attrs: {
                              href: _vm.$router.resolve({
                                name: "legacy.product.overview",
                                params: { id: item.value.id }
                              }).href
                            }
                          },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: item.value.name,
                                  "popper-class": "w-320",
                                  disabled: item.disableTooltip
                                }
                              },
                              [
                                _c("div", { staticClass: "ellipsis mr-3" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(itemIndex + 1) +
                                      " - " +
                                      _vm._s(item.value.name) +
                                      "\n                        "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-right gray-60 nowrap" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$filters.numberFormat(
                                        item.value.total
                                      )
                                    ) +
                                    " " +
                                    _vm._s(item.unit) +
                                    "\n                    "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "acenter" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$l10n.__(
                          "Pas de produits / services vendus pour ce client."
                        )
                      )
                    )
                  ])
                ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }